import React from 'react'
import { Box, Typography } from '@mui/material'
import styles from './CurateCard.module.scss'
import IconButton from '../iconButton/IconButton'

export default function CurateCard({ modalsOpen }) {
	return (
		<Box className={styles.CurateCard}>
			<Box className={styles.CurateCardImage}>
				<img src="/images/CurateCard.png" alt="WelCome.png" />
			</Box>
			<Box className={styles.CurateCardText}>
				<Box className={styles.CurateCardTextTitle}>
					<Typography variant="h2">
						Let’s Curate A
						<Typography variant="span">
							Customized Experience
						</Typography>
						For You!
					</Typography>
				</Box>
				<Box className={styles.CurateCardTextButton}>
					<IconButton onClick={modalsOpen}>
						<img
							src="/images/arrow_back.svg"
							alt="arrow_back.svg"
							width="20px"
							height="20px"
						/>
					</IconButton>
				</Box>
			</Box>
		</Box>
	)
}
